import FeedPage from '.';

export const Feed = ({ scrollDown, scrollToTop, logOut }) => (
  <FeedPage scrollDown={scrollDown} scrollToTop={scrollToTop} logOut={logOut} />
);
